<template>
  <div>
    <div class="panel-hdr pt-2 pb-3 categories">
      <div data-element="groups" class="d-flex flex-wrap">
        <div class="btn-group mr-2 mt-2">
            <button data-button="create" v-on:click="groupCreate" type="button" class="btn btn-outline-info btn-sm">
                Добавить категорию
            </button>
            <button data-button="settings" type="button" class="btn btn-outline-info btn-sm dropdown-toggle-split" v-if="groups.length > 0" v-on:click="settings = !settings" v-bind:class="{ active: settings }">
                <i class="fal fa-cog"></i>
            </button>
        </div>
        <div :data-id="group.id" class="btn-group mr-2 mt-2" v-for="(group, index) in groups" :key="group.id">
            <button :data-name="group.name" data-button="choose" type="button" class="btn btn-group btn-outline-info btn-sm" v-bind:class="{ active: groupActive == group.id }" v-on:click="groupSelect(group.id)">
                {{ group.name }}
            </button>
            <button data-button="edit" type="button" v-on:click="groupEdit(group)" class="btn btn-group-edit btn-outline-primary btn-sm dropdown-toggle-split" v-if="settings">
                <i class="fal fa-pencil"></i>
            </button>
            <button data-button="remove" type="button" v-on:click="groupRemove(group, index)" class="btn btn-group-remove btn-outline-secondary btn-sm dropdown-toggle-split" v-if="settings">
                <i class="fal fa-trash"></i>
            </button>
        </div>
      </div>
    </div>
    <GroupsEdit v-bind:group="editGroup" v-if="editStatus" v-on:close="groupEditClose"/>
    <GroupsCreate v-if="createStatus" :type="type" v-on:close="groupCreateClose"/>
  </div>
</template>

<script>
  import ComponentGroupsEdit from "@/components/groups/edit.vue";
  import ComponentGroupsCreate from "@/components/groups/create.vue";
  
  export default {
    props: ['group', 'type'],
    data() {
      return {
        // Категории
        groups: [],
        // Активная категория
        groupActive: this.group,
        // Отображение настроек
        settings: false,
        // Изменение категории
        editStatus: false,
        editGroup: {},
        // Создание категории
        createStatus: false,
      }
    },
    components: {
      GroupsEdit: ComponentGroupsEdit,
      GroupsCreate: ComponentGroupsCreate,
    },
    methods: {
      // Изменение задачи
      groupEdit (group) 
      {
        this.editGroup = {...group};
        this.editStatus = true;
      },
      // Завершение редактирования
      groupEditClose (groupsReload = false)
      {
        this.editStatus = false;
        this.editGroup = {};

        // Обновление списка задач при сохранении
        if(groupsReload)
          this.groupsListUpdate();
      },
      // Создание новой задачи
      groupCreate () 
      {
        this.createStatus = true;
      },
      // Завершение создания
      groupCreateClose (groupsReload = false)
      {
        this.createStatus = false;

        // Обновление списка задач при сохранении
        if(groupsReload)
          this.groupsListUpdate();
      },
      // Обновление списка категорий
      groupsListUpdate() 
      {
        // Отправка запроса к API
        this.$axios.get(process.env.VUE_APP_API_URL+'/v1/groups/'+this.type).then(response =>
        {
          this.groups = response.data.data.map(function(data)
          {
            return {id: data.id, name: data.name};
          });
        });
      },
      // Выбор категории
      groupSelect(id)
      {
        // Выбор активной категории
        if(this.groupActive == id)
          this.groupActive = null; 
        else
          this.groupActive = id; 
        
        // Передаем данные в родительский компонент
        this.$emit('groupSelect', this.groupActive);
      },
      // Удаление категории
      groupRemove(group, index) 
      {
        if(confirm('Вы действительно хотите удалить категорию "'+group.name+'"?'))
        {
          // При удалении активной категории, ставим "без категории"
          if(group.id == this.groupActive)
            this.groupSelect(null);
          else
            this.groupSelect(this.groupActive);

          this.$axios.get(process.env.VUE_APP_API_URL+'/v1/groups/'+group.id+'/remove');
          this.$delete(this.groups, index);
        }
      }
    },
    // Подгрузка данных
    mounted () 
    {
      this.groupsListUpdate();
    },
  }
</script>